module.exports = __webpack_public_path__ + "static/media/checkmarkv2.c6ad575e.svg";